<template>
  <div class="all">
    <div class="playPause">
      <div>
        <div @click="startPlay(item)" :class="isShowBtn ? 'bgColor' : 'bg'">
          <img src="../../../assets/play.png" class="pause" />
        </div>
        <div @click="pauseScratch" :class="!isShowBtn ? 'bgColor' : 'bg'">
          <img src="../../../assets/over.png" class="pause" />
        </div>
      </div>
      <div class="viewCode" @click="viewCode">查看源代码</div>
    </div>

    <div :key="keyNum" class="canvasBox">
      <div v-if="loading" class="loading">
        <!-- <Spin></Spin> -->
        <img src="../../../assets/loding.gif" alt="" />
      </div>

      <div v-if="flag" class="greenFlag">
        <div class="startFalg" @click="startPlay(item)">
          <img src="../../../assets/grflag.png" width="100%" />
        </div>
      </div>
      <!-- <canvas :id="'file' + keyNum" style="width: 100%;height: calc(100%);" :ref="'file' + keyNum" @mousedown="touchstart" @mousemove="touchmove" @mouseup="touchend"></canvas> -->
      <ScratchPlayer ref="ScratchPlayer" dyWidth="100%" dyHeight="6.3rem"></ScratchPlayer>
      <!-- 操作面板 -->
      <div v-show="isOpKey" class="opkey">
        <div v-if="item.keyBoardType === '1'" class="footer1">
          <div class="Div">直接观看或触摸操作</div>
          <div class="btn" @click="toFoldKey(item.keyBoardType)">收起</div>
        </div>

        <div v-if="item.keyBoardType === '2' && isOpKey" class="footer">
          <div class="footer_left">
            <div class="turn_left">
              <div class="btn_box" @mousedown="clickBtn('left')" @mouseup="clickStop('left')">
                <img src="../../../assets/operation/left.png" alt="" />
              </div>
            </div>
            <div class="turn_direction">
              <div class="btn_box" @mousedown="clickBtn('top')" @mouseup="clickStop('top')">
                <img src="../../../assets/operation/top.png" alt="" />
              </div>
              <div class="btn_box" @mousedown="clickBtn('bottom')" @mouseup="clickStop('bottom')">
                <img src="../../../assets/operation/bottom.png" alt="" />
              </div>
            </div>
            <div class="turn_right">
              <div class="btn_box" @mousedown="clickBtn('right')" @mouseup="clickStop('right')">
                <img src="../../../assets/operation/right.png" alt="" />
              </div>
            </div>
          </div>
          <div class="footer_right">
            <div @mousedown="clickBtn('space')" @mouseup="clickStop('space')">
              <img src="../../../assets/operation/space (2).png" alt="" />
            </div>
          </div>
          <div class="btn" @click="toFoldKey(item.keyBoardType)">收起</div>
        </div>
        <div v-if="item.keyBoardType === '3' && isOpKey" class="footer">
          <div class="footer2_left">
            <div class="turn_left">
              <div class="btn_box" @mousedown="clickBtn('a')" @mouseup="clickStop('a')">
                <img src="../../../assets/operation/A.png" alt="" />
              </div>
            </div>
            <div class="turn_direction">
              <div class="btn_box" @mousedown="clickBtn('w')" @mouseup="clickStop('w')">
                <img src="../../../assets/operation/W.png" alt="" />
              </div>
              <div class="btn_box" @mousedown="clickBtn('s')" @mouseup="clickStop('s')">
                <img src="../../../assets/operation/S.png" alt="" />
              </div>
            </div>
            <div class="turn_right">
              <div class="btn_box" @mousedown="clickBtn('d')" @mouseup="clickStop('d')">
                <img src="../../../assets/operation/D.png" alt="" />
              </div>
            </div>
          </div>
          <div class="footer2_right">
            <div class="turn_left">
              <div class="btn_box" @mousedown="clickBtn('h')" @mouseup="clickStop('h')">
                <img src="../../../assets/operation/H.png" alt="" />
              </div>
            </div>
            <div class="turn_direction">
              <div class="btn_box" @mousedown="clickBtn('u')" @mouseup="clickStop('u')">
                <img src="../../../assets/operation/U.png" alt="" />
              </div>
              <div class="btn_box" @mousedown="clickBtn('k')" @mouseup="clickStop('k')">
                <img src="../../../assets/operation/K.png" alt="" />
              </div>
            </div>
            <div class="turn_right">
              <div class="btn_box" @mousedown="clickBtn('l')" @mouseup="clickStop('l')">
                <img src="../../../assets/operation/L.png" alt="" />
              </div>
            </div>
          </div>
          <div class="btn" @click="toFoldKey(item.keyBoardType)">收起</div>
        </div>
        <div v-if="item.keyBoardType === '4' && isOpKey" class="footer">
          <div class="footer3">
            <div class="turn_box">
              <div class="turn_left">
                <div class="btn1_box" @mousedown="clickBtn('u')" @mouseup="clickStop('u')">
                  <img src="../../../assets/operation/U.png" alt="" />
                </div>
                <div class="btn1_box" @mousedown="clickBtn('a')" @mouseup="clickStop('a')">
                  <img src="../../../assets/operation/A.png" alt="" />
                </div>
                <div class="btn1_box" @mousedown="clickBtn('z')" @mouseup="clickStop('z')">
                  <img src="../../../assets/operation/Z.png" alt="" />
                </div>
              </div>
              <div class="turn_middle">
                <div class="btn1_box" @mousedown="clickBtn('k')" @mouseup="clickStop('k')">
                  <img src="../../../assets/operation/K.png" alt="" />
                </div>
                <div class="btn1_box" @mousedown="clickBtn('s')" @mouseup="clickStop('s')">
                  <img src="../../../assets/operation/S.png" alt="" />
                </div>
                <div class="btn1_box" @mousedown="clickBtn('x')" @mouseup="clickStop('x')">
                  <img src="../../../assets/operation/X.png" alt="" />
                </div>
              </div>
              <div class="turn_right">
                <div class="btn1_box" @mousedown="clickBtn('l')" @mouseup="clickStop('l')">
                  <img src="../../../assets/operation/L.png" alt="" />
                </div>
                <div class="btn1_box" @mousedown="clickBtn('d')" @mouseup="clickStop('d')">
                  <img src="../../../assets/operation/D.png" alt="" />
                </div>
                <div class="btn1_box" @mousedown="clickBtn('c')" @mouseup="clickStop('c')">
                  <img src="../../../assets/operation/C.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div class="btn" @click="toFoldKey(item.keyBoardType)">收起</div>
        </div>
        <div v-if="item.keyBoardType === '5' && isOpKey" class="footer1">
          <div class="Div">未适配手机端，请至电脑操作</div>
          <div class="btn" @click="toFoldKey(item.keyBoardType)">收起</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _VM from 'scratch-vm'
// import _Storage from 'scratch-storage'
import _SvgRender from 'scratch-svg-renderer'
import _Render from 'scratch-render'
import AudioEngine from 'scratch-audio'
import { getOssDownloadUrl, getInfo } from '@/api/index'
import ScratchPlayer from 'scratch-player'
import { getRequest } from '@/libs/axios'
export default {
  name: 'scratchPlay',
  components: { ScratchPlayer },
  // 父组件 函数传参式赋值
  props: {
    ossPath: {
      type: String,
      default: null
    },
    keyNum: {
      type: String,
      default: null
    },
    opusId: {
      type: String,
      default: null
    },
    studentId: {
      type: String,
      default: null
    },
    item: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: true,
      vm: {},
      flag: false,
      info: {},
      isOpKey: false, // 操作键
      // opusId: '',
      isShowBtn: true
    }
  },
  mounted() {
    this.loadScratchProject()
    this.initEventListener()
  },

  methods: {
    viewCode() {
      let routeUrl = this.$router.resolve({
        path: '../peixun/showScratch',
        // query: { opusName: this.opusName, ossPath: this.ossPath }
        query: { opusId: this.opusId, studentId: this.studentId, ossPath: this.ossPath }
      })
      window.open(routeUrl.href, '_blank')
    },
    async loadScratchProject() {
      // let getData = { opusId: this.item.opusId }
      // this.loading = true
      // const res = await getRequest('/v3/student/getOpusDetails', getData, true)
      // this.loading = false
      // if (!res.success) return false
      // this.info = res.result
      // this.opusName = this.info.opusSimpleDto.opusName
      // this.studentName = this.info.opusSimpleDto.studentName
      // this.className = this.info.opusSimpleDto.className
      // this.info.keyBoardType = this.info.opusSimpleDto.keyBoardType
      // var materialUrl = this.info.opusList.find(it => it.materialType === 3).materialUrl
      let getData = { ossPath: this.ossPath, dirPath: 'opus' }
      this.flag = true
      const res2 = await getRequest('/v3/student/getOpusPathFormAliOss', getData, true)

      if (!res2.success) return false
      var downLoadUrl = res2.result.downLoadUrl
      var that = this
      fetch(downLoadUrl, { cache: 'no-cache' })
        .then(response => {
          if (response.status == 404) {
            // downLoadUrl = 'https://xiongbangzhu.oss-cn-beijing.aliyuncs.com/opus/181983437781995520_2020-07-15T01:39:40.370Z'
            if (downLoadUrl.includes('xiongbangzhu')) {
              downLoadUrl = downLoadUrl.replace(/xiongbangzhu/, 'dianyipublicoss')
            } else {
              downLoadUrl = downLoadUrl.replace(/dianyipublicoss/, 'xiongbangzhu')
            }
            console.log(downLoadUrl,'downLoadUrl2')
            fetch(downLoadUrl, { cache: 'no-cache' }).then(response2 => {
              response2.arrayBuffer().then(buffer => {
                that.$refs.ScratchPlayer.start()
                that.$refs.ScratchPlayer.loadProject(buffer, that.hiddenLoading)
              })
            })
          } else {
            response.arrayBuffer().then(buffer => {
              that.$refs.ScratchPlayer.start()
              that.$refs.ScratchPlayer.loadProject(buffer, that.hiddenLoading)
            })
          }
        })
        .catch(e => {
          alert(e)
        })
    },
    initEventListener() {
      document.addEventListener('keydown', e => {
        if (e.target !== document && e.target !== document.body) {
          return
        }
        if (this.$refs.ScratchPlayer) {
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: e.key,
            isDown: true
          })
        }
      })
      document.addEventListener('keyup', e => {
        if (this.$refs.ScratchPlayer) {
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: e.key,
            isDown: false
          })
        }
      })
    },
    startPlay(item) {
      this.isShowBtn = true
      this.flag = false
      this.$refs.ScratchPlayer.greenFlag()
      this.isOpKey = true
    },
    clickBtn(bkey) {
      switch (bkey) {
        case 'left':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: 'ArrowLeft',
            isDown: true
          })
          break
        case 'a':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: 'ArrowLeft',
            isDown: true
          })
          break
        case 'h':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: 'ArrowLeft',
            isDown: true
          })
          break
        case 'top':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: 'ArrowUp',
            isDown: true
          })
          break
        case 'w':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: 'ArrowUp',
            isDown: true
          })
          break
        case 'u':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: 'ArrowUp',
            isDown: true
          })
          break
        case 'bottom':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: 'ArrowDown',
            isDown: true
          })
          break
        case 's':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: 'ArrowDown',
            isDown: true
          })
          break
        case 'k':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: 'ArrowDown',
            isDown: true
          })
          break
        case 'right':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: 'ArrowRight',
            isDown: true
          })
          break
        case 'd':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: 'ArrowRight',
            isDown: true
          })
          break
        case 'l':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: 'ArrowRight',
            isDown: true
          })
          break
        case 'space':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: ' ',
            isDown: true
          })
          break
        default:
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: bkey,
            isDown: true
          })
      }
    },
    clickStop(bkey) {
      switch (bkey) {
        case 'left':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: 'ArrowLeft',
            isDown: false
          })
          break
        case 'a':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: 'ArrowLeft',
            isDown: false
          })
          break
        case 'h':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: 'ArrowLeft',
            isDown: false
          })
          break
        case 'top':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: 'ArrowUp',
            isDown: false
          })
          break
        case 'w':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: 'ArrowUp',
            isDown: false
          })
          break
        case 'u':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: 'ArrowUp',
            isDown: false
          })
          break
        case 'bottom':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: 'ArrowDown',
            isDown: false
          })
          break
        case 's':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: 'ArrowDown',
            isDown: false
          })
          break
        case 'k':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: 'ArrowDown',
            isDown: false
          })
          break
        case 'right':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: 'ArrowRight',
            isDown: false
          })
          break
        case 'd':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: 'ArrowRight',
            isDown: false
          })
          break
        case 'l':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: 'ArrowRight',
            isDown: false
          })
          break
        case 'space':
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: ' ',
            isDown: false
          })
          break
        default:
          this.$refs.ScratchPlayer.postIOData('keyboard', {
            key: bkey,
            isDown: false
          })
      }
    },
    toFoldKey(type) {
      console.log(type)
      switch (type) {
        case '1':
          this.isOpKey = false
          break
        case '2':
          this.isOpKey = false
          break
        case '3':
          this.isOpKey = false
          break
        case '4':
          this.isOpKey = false
          break
        case '5':
          this.isOpKey = false
          break
      }
    },
    pauseScratch() {
      this.isShowBtn = false
      this.flag = true
      this.stopAll()
      this.isOpKey = false
    },
    stopAll() {
      this.$refs.ScratchPlayer.stop()
    }
  },
  beforeDestroy() {
    this.stopAll()
  }
}
</script>
<style lang="less" scoped>
.title {
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  padding: 10px 0;
  background-color: #e3e3e3;
  position: relative;
  span {
    font-size: 14px;
    color: #fad142;
    margin-left: 10px;
  }
  img {
    position: absolute;
    top: 50%;
    left: 9px;
    width: 11px;
    height: 18px;
    transform: translateY(-50%);
  }
}

img {
  pointer-events: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}
.middle {
  height: 40px;
  width: 100%;
  margin-top: -5px;
  background-color: rgba(252, 144, 17, 0.1);
  text-align: center;
  div {
    display: inline-block;
  }
}
.canvasBox {
  position: relative;
  // height: calc(55% - 75px);
  height: calc(100%);
  .greenFlag {
    position: absolute;
    width: 100%;
    height: calc(99%);
    // height: calc(92.5%);
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 9998;
    .startFalg {
      width: 60px;
      height: 60px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .teacherRate {
      width: 100%;
      height: 30px;
      position: absolute;
      top: 278px;
      // transform: translate(10%,0);
      color: #fff;
      background-color: rgba(0, 0, 0, 0.3);
      padding: 10px 0px 10px 20px;
      display: flex;
      align-items: center;
      span {
        margin-right: 5px;
      }
    }
  }
  .loading {
    position: absolute;
    width: 100%;
    height: calc(100%);
    background-color: #fff;
    display: flex;
    justify-content: space-around;
    align-items: center;
    // div {
    //   width: 100px;
    //   height: 60px;
    //   position: absolute;
    //   left: 50%;
    //   top: 50%;
    //   transform: translate(-50%, -50%);
    // }
    img {
      width: 50%;
      height: 50%;
    }
  }
}
// #file {
//   width: 100%;
//   height: calc(100%);
// }
.btn_box {
  height: 51px;
  width: 51px;
  background-color: #fff;
  border-radius: 50%;
  position: relative;
  box-shadow: 0 4px 8px 0 rgba(87, 87, 87, 0.2);
}
.opusjs {
  margin: 10px;
  .opusTitle {
    font-size: 13pt;
    font-weight: bold;
    color: #333333;
  }
  p {
    text-indent: 20px;
    font-size: 12pt;
    color: #333333;
  }
}
.opkey {
  height: 230px;
}
.footer1 {
  height: 100%;
  // margin-top:-5px;
  background-color: rgba(0, 0, 0, 0.2);
  position: relative;
  // padding-bottom: 40px;
  box-sizing: border-box;
  position: relative;
  z-index: 1;

  .Div {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    width: 80%;
    text-align: center;
    // word-wrap: none;
  }
}
.footer {
  display: flex;
  height: 100%;
  position: relative;
  // margin-top:-10px;
  background-color: rgba(0, 0, 0, 0.9);
  // padding-bottom: 50px;
  box-sizing: border-box;
  z-index: 1;
  .footer2_left {
    flex: 3;
    display: flex;
    /*height: 80%;*/
    align-items: center;
    img {
      width: 51px;
      height: 51px;
    }
    .turn_left {
      flex: 2;
      display: flex;
      justify-content: flex-end;
      .btn_box {
        height: 51px;
        width: 51px;
        background-color: #fff;
        border-radius: 50%;
        position: relative;
        .left_button {
          height: 0;
          width: 0;
          border: 10px solid transparent;
          border-right: 14px solid #bc7942;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-78%, -50%);
        }
      }
    }
    .turn_direction {
      flex: 1;
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: center;
      align-items: center;
      /*padding: 10% 0;*/
      box-sizing: border-box;
      & > div:nth-child(1) {
        margin-bottom: 33px;
        position: relative;
        .top_button {
          height: 0;
          width: 0;
          border: 10px solid transparent;
          border-bottom: 14px solid #bc7942;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -78%);
        }
      }
      & > div:nth-child(2) {
        position: relative;
        .bottom_button {
          height: 0;
          width: 0;
          border: 10px solid transparent;
          border-top: 14px solid #bc7942;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -22%);
        }
      }
    }
    .turn_right {
      flex: 2;
      text-align: left;
      & > div {
        position: relative;
        .right_button {
          height: 0;
          width: 0;
          border: 10px solid transparent;
          border-left: 14px solid #bc7942;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-22%, -50%);
        }
      }
    }
  }
  .footer2_right {
    flex: 3;
    display: flex;
    /*height: 80%;*/
    align-items: center;
    img {
      width: 51px;
      height: 51px;
    }
    .turn_left {
      flex: 2;
      display: flex;
      justify-content: flex-end;
      .btn_box {
        height: 51px;
        width: 51px;
        background-color: #fff;
        border-radius: 50%;
        position: relative;
        .left_button {
          height: 0;
          width: 0;
          border: 10px solid transparent;
          border-right: 14px solid #bc7942;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-78%, -50%);
        }
      }
    }
    .turn_direction {
      flex: 1;
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: center;
      align-items: center;
      /*padding: 10% 0;*/
      box-sizing: border-box;
      & > div:nth-child(1) {
        margin-bottom: 33px;
        position: relative;
        .top_button {
          height: 0;
          width: 0;
          border: 10px solid transparent;
          border-bottom: 14px solid #bc7942;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -78%);
        }
      }
      & > div:nth-child(2) {
        position: relative;
        .bottom_button {
          height: 0;
          width: 0;
          border: 10px solid transparent;
          border-top: 14px solid #bc7942;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -22%);
        }
      }
    }
    .turn_right {
      flex: 2;
      text-align: left;
      & > div {
        position: relative;
        .right_button {
          height: 0;
          width: 0;
          border: 10px solid transparent;
          border-left: 14px solid #bc7942;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-22%, -50%);
        }
      }
    }
  }
  .footer3 {
    flex: 1;
    display: flex;
    /*height: 80%;*/
    align-items: center;
    img {
      width: 51px;
      height: 51px;
    }
    .turn_box {
      flex: 1;
      display: flex;
      .turn_left {
        flex: 2;
        .btn1_box {
          width: 100%;
          text-align: right;
        }
      }
      .turn_middle {
        flex: 1;
        text-align: center;
      }
      .turn_right {
        flex: 2;
      }
    }
  }
  .footer_left {
    flex: 3;
    display: flex;
    /*height: 80%;*/
    align-items: center;
    img {
      width: 51px;
      height: 51px;
    }
    .turn_left {
      flex: 2;
      display: flex;
      justify-content: flex-end;
      .btn_box {
        height: 51px;
        width: 51px;
        background-color: #fff;
        border-radius: 50%;
        position: relative;
        .left_button {
          height: 0;
          width: 0;
          border: 10px solid transparent;
          border-right: 14px solid #bc7942;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-78%, -50%);
        }
      }
    }
    .turn_direction {
      flex: 1;
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: center;
      align-items: center;
      /*padding: 10% 0;*/
      box-sizing: border-box;
      & > div:nth-child(1) {
        margin-bottom: 33px;
        position: relative;
        .top_button {
          height: 0;
          width: 0;
          border: 10px solid transparent;
          border-bottom: 14px solid #bc7942;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -78%);
        }
      }
      & > div:nth-child(2) {
        position: relative;
        .bottom_button {
          height: 0;
          width: 0;
          border: 10px solid transparent;
          border-top: 14px solid #bc7942;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -22%);
        }
      }
    }
    .turn_right {
      flex: 2;
      text-align: left;
      & > div {
        position: relative;
        .right_button {
          height: 0;
          width: 0;
          border: 10px solid transparent;
          border-left: 14px solid #bc7942;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-22%, -50%);
        }
      }
    }
  }
  .footer_right {
    flex: 2;
    position: relative;
    div {
      /*width: 92px;*/
      /*height: 40px;*/
      // width:100px;
      // height:40px;
      // background:rgba(255,255,255,1);
      // box-shadow:0 10px 10px 0 rgba(87,87,87,0.39);
      position: absolute;
      border-radius: 40px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      // font-size: 18px;
      // color: #BC7942;
      text-align: center;
      // line-height: 40px;
      // letter-spacing: 3px;
    }
    // div:after{
    //   content: "";
    //   width: 88px;
    //   height: 32px;
    //   border: 1px solid #FFFFFF;
    //   position: absolute;
    //   top: 50%;
    //   left: 50%;
    //   transform: translate(-50%,-50%);
    //   box-shadow:0px .5px 5px 0px rgba(188,121,66,0.6) inset;
    //   border-radius: 40px;
    // }
  }
  // }
  // }
}
.btn {
  position: absolute;
  top: 0.1rem;
  right: 0.1rem;
  cursor: pointer;
  width: 0.5rem;
  height: 0.5rem;
  line-height: 0.5rem;
  text-align: center;
  border-radius: 50%;
  // background-color: #ccc;
  color: #666;
}
.all {
  background-color: #f3f3f3;
  padding-top: 0.07rem;
  border-radius: 0.1rem;
  overflow: hidden;
}
.playPause {
  display: flex;
  align-items: center;
  padding: 0 0.1rem;
  margin-bottom: 0.1rem;
  justify-content: space-between;
  img {
    width: 0.36rem;
    height: 0.36rem;
  }
  .pause {
    width: 0.2rem;
    height: 0.2rem;
  }
  .viewCode {
    width: 1rem;
    height: 0.37rem;
    line-height: 0.37rem;
    text-align: center;
    font-size: 0.14rem;
    color: #fff;
    background-color: #ffa000;
    border-radius: 0.06rem;
    cursor: pointer;
  }
}
.bg {
  display: inline-flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 0.05rem;
  width: 0.3rem;
  height: 0.3rem;
}
.bgColor {
  display: inline-flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 0.05rem;
  width: 0.3rem;
  height: 0.3rem;
  background-color: #b1d2ff;
}
.bgColorPause {
  margin-left: 0.1rem;
}
</style>



// WEBPACK FOOTER //
// src/views/teacher/components/scratchPlayTech.vue